module.exports = __webpack_public_path__ + "static/ashleigh-d1dd57c3edb8e085509b8d92b33fa7a4.webp";